// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCostDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.983 17.829 12.418 20.4a.49.49 0 0 1-.685 0L9.16 17.829a.477.477 0 0 1-.144-.343.49.49 0 0 1 .48-.487.477.477 0 0 1 .343.144l1.752 1.714v-3.771h-.158c-2.016-.168-3.085-1.173-3.085-1.835 0-.342.336-.596.493-.685a3.836 3.836 0 0 0 2.551 1.491l.206.041v-3.661l-.13-.031a9.138 9.138 0 0 1-.456-.124c-1.194-.34-2.4-.915-2.4-2.63 0-1.443 1.11-2.52 2.825-2.742l.147-.02v-.858a.484.484 0 0 1 .964 0v.874h.154c1.78.165 2.726 1.04 2.726 1.608a.917.917 0 0 1-.515.686 3.521 3.521 0 0 0-2.163-1.282l-.202-.035v3.549l.13.03c.116.028.23.06.37.1.213.062.412.127.604.2 1.36.517 1.995 1.312 1.995 2.499 0 1.587-1.073 2.616-2.949 2.825h-.15v3.805l1.748-1.748a.487.487 0 0 1 .79.157.49.49 0 0 1-.105.529zm-2.43-3.758.201-.038c1.046-.195 1.619-.795 1.619-1.69a1.372 1.372 0 0 0-.563-1.111 2.33 2.33 0 0 0-.439-.26 4.515 4.515 0 0 0-.6-.23l-.219-.065zm-.964-8.164-.206.045c-.963.206-1.536.826-1.536 1.653-.015.333.097.66.312.915.055.057.113.111.175.161l.037.028c.055.04.114.078.175.116h.031c.167.089.341.162.521.22l.275.082.216.062z"
    />
  </svg>
);
export default SvgCostDown;
